import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from '../services/user.service';

import { ToastrUtilsService } from '../services/toastr-utils.service';
import { usermaster, interaction, division, user } from '../models/admin';
import { MasterMOMService } from '../services/master-mom.service';
import { UtilityService } from '../services/utility.service';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import Notiflix from "notiflix";
import { AttendeesAtd } from '../models/MOMForm';
import { formatDate } from '@angular/common';
import { pairText } from '../models/users';
import { AdminService } from '../services/admin.service';
import { RSAHelper } from '../models/RSAHelper';

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.css'],
  providers: [ToastrUtilsService]
})
export class UserprofileComponent implements OnInit {
  modalresetPassword: BsModalRef;
  @ViewChild('userProfilePictueUpdate', { static: false }) userProfilePictueUpdate: TemplateRef<any>;
  login_UserID: number; // number
  
  imageChangedEvent: any = '';
  croppedImage: any = '';
  public user: any = {};
  userInfoList: any = [];
  noDataImage: string;
  public pageAction: string = 'add';
  todayTime = new Date().toLocaleTimeString()
  todayDate = new Date().toLocaleDateString();
  model: any = {};
  showCropper = false;
  user_data: any = [];
  modalRef: any;
    profilePicture: any;
  userFollowUpList: any = [];
  followUpUserList: any = [];
  isDelegate: boolean = false;
  isCopyEmail: boolean = false;
  public ngbModalOptions: any = {
  backdrop: 'static',
  keyboard: false
  };
  public accessValue = [{ value: 1, text: 'Read Access' }, { value: 2, text: 'Full Access' }];
    isExternal: any;
  UserList: any = [];
    isLoading: any;
    strK1: string;
    strI1: string;
  constructor(public utilityService: UtilityService,
    private toastr: ToastrUtilsService,
    public momMasterservice: MasterMOMService,
    private userService: UserService,
    private modalService: BsModalService,
    private _router: Router,
    public restApi: AdminService,
    ) { }

  ngOnInit(): void {
    this.noDataImage = this.utilityService.getnodataImage();
    ;
    var user = this.userService.getUserInfo();
    if(user==undefined){
      this.userService.logout();
    }
    else{
      this.login_UserID = user.id;
    }

    this.loadpairText();
    this.loadUserMaster();
    this.loadAllUsers();
    this.loadFollowUpUser();
    this.getUserList();
    let that = this;
    setTimeout(function () {
      that.loadUserInfo();
    }, 1000);
  }


  //Get User List
  getUserList() {
    let inpValue = new AttendeesAtd();
    inpValue.userUno = this.login_UserID;
    this.momMasterservice.getUserList(inpValue)
      .subscribe((data:any) => {
        data = data.filter((d)=>d.userselUno !== Number(inpValue.userUno));        
        this.UserList = data;

      },
        () => {
        }
      ).add(() => {
      });
  }
  openResetPasswordModal(template: TemplateRef<any>) {
    this.modalresetPassword = this.modalService.show(template, Object.assign({}, { class: 'modal-md' }, this.ngbModalOptions));
  }
 //Get User List
  getSelUserAtd() {
    ;
  let inpValue = new AttendeesAtd();
  inpValue.userUno = this.login_UserID;
  if (this.userService.UserList.length == 0) {
    this.momMasterservice.getUserList(inpValue)
      .subscribe(data => {
        this.userService.UserList = data;
        this.userFollowUpList = this.userService.UserList;
        console.log("follow", this.userService.UserList)
      },
        () => {

        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  else {

  }
}
  openModalImage(template2: TemplateRef<any>) {

    this.modalRef = this.modalService.show(template2, Object.assign({}, { class: 'gray modal-lg modal-dialog-scrollable' }, this.ngbModalOptions)
    );

    //this.modalPub.hide();
  }
  loadUserInfo() {
    // Notiflix.Loading.Standard('Please Wait...', '.pageloadcontainer');
    Notiflix.Block.Dots('.pageloadcontainer');
    //this.spinner.show();
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.login_UserID;
    inpValue.condition = 8;
    inpValue.startIndex = 0;
    inpValue.maxCount = 0;
    this.momMasterservice.getUserMasters(inpValue)
      .subscribe(data => {
       

        if (data != null && data != undefined) {
          console.log("userinformation", data);
          let dataItemList: any = [];
          dataItemList = data;
          this.userInfoList = data[0];
          this.model.displayNameEn = data[0].displayNameEn;
          this.model.displayNameAr = data[0].displayNameAr;
          this.model.firstname = data[0].firstname;
          this.model.lastname = data[0].lastname;
          this.profilePicture = data[0].picture;
          this.model.followUp = data[0].followUp != '' && data[0].followUp != undefined && data[0].followUp != null ?data[0].followUp:null;
          this.model.startDate = data[0].startDate;
          this.model.endDate = data[0].endDate;
          this.model.access = data[0].isAccess != '' && data[0].isAccess != undefined && data[0].isAccess != null ? data[0].isAccess : null;
          this.isDelegate = data[0].isDelegate == 1 ? true : false;
          this.isCopyEmail = data[0].isCopyEmail == 1 ? true : false;
          this.isExternal = data[0].externalUser;
        }
        else {
          this.userInfoList = [];
        }
       
        setTimeout(function () {
          Notiflix.Block.Remove('.pageloadcontainer', 800)
        }, 500);
       
      },
        (error) => {
          Notiflix.Loading.Remove();
          // this.spinner.hide();
        }
      ).add(() => {
        Notiflix.Loading.Remove();
        ///this.spinner.hide();
      });
  }

  imageLoaded() {
    this.showCropper = true;

  }
  fileChangeEvent(event: any): void {
    ;
    this.imageChangedEvent = event;
  }
  imageCropped(event: any) {
    this.croppedImage = event.base64;
  }
  clearImage() {
    this.croppedImage = '';
    this.imageChangedEvent = '';
  }
  saveImage() {

    if (this.isLoading)
      return;
    this.isLoading = true;
    let inpValue = new user();
    inpValue.languageUno = 1033;
    inpValue.userImage = this.croppedImage;
    inpValue.userUno = this.login_UserID;


    this.momMasterservice.uploadProfileImage(inpValue)
      .subscribe(data => {
        this.isLoading = false;
        this.user = this.userService.getUserInfo();
        this.user.picture = this.croppedImage;
        localStorage.setItem('userinfo', JSON.stringify(this.user));
        var imgprof: any = document.getElementById("imgProfile")
        if (imgprof) imgprof.src = this.croppedImage;
        this.croppedImage = '';
        this.imageChangedEvent = '';
        this.loadUserInfo();
        this.toastr.SaveMessage();
        this.modalRef.hide();
        
      },
        () => {
          //Called when error
         // this.toastr.ErrorMessage();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.toastr.ErrorMessage();
      });

  }


  loadAllUsers() {
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.login_UserID;
    inpValue.condition =10;
    inpValue.startIndex = 0;
    inpValue.maxCount = 0;
    this.momMasterservice.getUserMasters(inpValue)
      .subscribe(data => {

        this.userFollowUpList = data;
        console.log(this.userFollowUpList, 'userdata');

      },
        (error) => {
          Notiflix.Loading.Remove();
          // this.spinner.hide();
        }
      ).add(() => {
        Notiflix.Loading.Remove();
        ///this.spinner.hide();
      });
  }
  loadUserMaster() {
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.login_UserID;
    inpValue.condition =10;
    inpValue.startIndex = 1;
    inpValue.maxCount =20000;
    this.momMasterservice.getUserMasters(inpValue)
      .subscribe(data => {

        this.user_data = data;
      },
        (error) => {
          Notiflix.Loading.Remove();
          // this.spinner.hide();
        }
      ).add(() => {
        Notiflix.Loading.Remove();
        ///this.spinner.hide();
      });
  }
  AddEditUserMaster(data1: any) {
    ;
    if (this.compareDate(this.model.startDate, this.model.endDate)) {
      this.toastr.ErrorCustomMessage('Start date should be lesser than End date');
      return false;
    }
    // if (this.DuplicateNameCheck(this.utilityService.isStringNull(data1.firstname), this.utilityService.isNumericNull(data1.id))) {
    //   this.toastr.ErrorCustomMessage('Duplicates not allowed');
    //   return false;
    // }
    // else {
      if (this.isLoading)
        return false;

      let objUser = new usermaster();
      this.isLoading = true;
      objUser.actionType = "edit";
      objUser.iD = this.login_UserID;
      objUser.ntUsername = this.utilityService.isStringNull(data1.ntUsername);
      objUser.prNumber = this.utilityService.isStringNull(data1.prNumber);
      objUser.displayNameEn = this.utilityService.isStringNull(this.model.displayNameEn);
      objUser.displayNameAr = this.utilityService.isStringNull(this.model.displayNameAr);
      objUser.followUp = this.utilityService.isNumericNull(this.model.followUp);
      objUser.emailId = this.utilityService.isStringNull(data1.emailId);
      //objUser.firstname = this.utilityService.isStringNull(this.model.firstname);
      //objUser.lastname = this.utilityService.isStringNull(this.model.lastname);
      objUser.designationEn = this.utilityService.isStringNull(data1.designationEn);
      objUser.designationAr = this.utilityService.isStringNull(data1.designationAr);
      objUser.divisionUno = this.utilityService.isNumericNull(data1.divisionUno);

      if(!this.model.followUp) {
        objUser.startDate = null;
        objUser.endDate = null;
        objUser.isAccess = 0;
        objUser.isDelegate = 0
        objUser.isCopyEmail = 0
      }
      else {
        objUser.startDate = this.model.startDate != '' ? this.model.startDate:null;
        objUser.endDate = this.model.endDate != '' ? this.model.endDate:null;
        objUser.isAccess = this.utilityService.isNumericNull(this.model.access);
        objUser.isDelegate = this.isDelegate == true ? 1 : 0;
        objUser.isCopyEmail = this.isCopyEmail == true ? 1 : 0;
      }
     
      objUser.userUno = this.login_UserID;

      this.momMasterservice.addEditUserMaster(objUser)
        .subscribe(data => {
            this.toastr.SaveMessage();
          this.loadUserInfo();
          this.isLoading = false;
        },
          () => {
            //Called when error
           // this.toastr.ErrorMessage();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.toastr.ErrorMessage();
        });
      return true;
    // }
  }


  DeleteConfirm(data: any) {
    let temp = this;
    Notiflix.Confirm.Show('Delete Confirm', 'Are you sure you want to delete?', 'Yes', 'No', function () {

      Notiflix.Loading.Standard('Loading...');
      temp.DeleteImage(data);

    }, function () { // No button callback
      return false;
    });

  }
  DeleteImage(data1: any) {

    let obj = new usermaster();
    obj = data1;
    obj.condition = 3;
    obj.userUno = this.login_UserID;
    //objDeaprtment.tenantUno = 1;

    this.momMasterservice.deleteUserMaster(obj)
      .subscribe(() => {
        this.toastr.DeleteMessage();
        this.profilePicture = '';
        Notiflix.Loading.Remove();
        // this.spinner.hide();
      },
        () => {
          this.toastr.ErrorMessage();
          //Called when error
          // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }
  DuplicateNameCheck(firstname: string, id: number) {
    var rtnValue = false;
    if (this.user_data != null && this.user_data != undefined) {

      this.user_data.forEach((grdData) => {

        if (grdData.firstname.toLocaleLowerCase() == firstname.toLocaleLowerCase() && id != grdData.id) {
          rtnValue = true;
        }
      });
    }
    return rtnValue;
  }
  loadFollowUpUser() {

    //this.spinner.show();
    let inpValue = new usermaster();
    inpValue.userUno = this.login_UserID;
    inpValue.startIndex = 1;
    inpValue.maxCount = 10;
    this.momMasterservice.getFollowUpUsers(inpValue)

      .subscribe(data => {

        this.followUpUserList = data;

        console.log(this.followUpUserList, "followUpUser");
        //this.spinner.hide();
      },
        (error) => {
          //Called when error
          // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  loadpairText() {
    ;
    let inpValue = new pairText();
    inpValue.k1 = '';
    this.restApi.callpairText(inpValue)
      .subscribe(data => {
        ;
        let rtnData: pairText;
        rtnData = data;
        this.strK1 = rtnData.k1;
        this.strI1 = rtnData.i1;
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  //Compare Two Dates
  compareDate(startDate: any, endDate: any) {
    //var d1 = new Date('2020-01-23'); //yyyy-mm-dd  
    //var d2 = new Date('2020-01-21'); //yyyy-mm-dd
    let returnValue: boolean = false;
    let d1 = new Date(startDate);
    let d2 = new Date(endDate);
    if (d1 > d2) {
      returnValue = true;
    }



    return returnValue;
  }
  updatePassword() {
    ;

    if (this.model.password != '' && this.model.confirmPassword != '') {
      let objUser = new usermaster();


      var objRSAHelper = new RSAHelper();       
      // var encryptPassword = btoa(this.model.password);
      // var encryptConfirmPassword = btoa(this.model.confirmPassword);
       var encryptPassword = objRSAHelper.encryptWithPublicKey(this.model.password);
       var encryptConfirmPassword = objRSAHelper.encryptWithPublicKey(this.model.confirmPassword);
      objUser.password = this.utilityService.isStringNull(encryptPassword);
      objUser.confirmPassword = this.utilityService.isStringNull(encryptConfirmPassword);
      objUser.userName = '';
      objUser.userUno = this.login_UserID;
      objUser.condition = 3;
      this.momMasterservice.resetPassword(objUser)
        .subscribe(data => {
          if (data == "success") {
            this.toastr.SaveMessage();
            this.model.password = "";
            this.model.confirmPassword = "";
            this.modalresetPassword.hide();
          }
          else {
            this.toastr.ErrorMessage();
          }
        },
          () => {
            //Called when error
            // this.toastr.ErrorMessage();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.toastr.ErrorMessage();
        });
    }
    else {
      this.toastr.ValidationMessage();
    }

  }
  redirectDelegateMeetingMinutes(id: any, isAccess: any, isDelegate: any) {
    
    var id1 = btoa(id);
    var isAccess1 = btoa(isAccess);
    var isDelegate1 = btoa(isDelegate);
    this._router.navigate(['/delegatemeetingminutes'], { queryParams: { QId: id1, QAccess: isAccess1, QDelegate: isDelegate1 } });

  }

  customSearchFn(term: string, item: any) {
    ;
    term = term.toLowerCase();
    return item.fullAttendeeName.toLowerCase().includes(term) || item.emailAtd.toLowerCase().includes(term);
  }
}
